import { render, staticRenderFns } from "./ClientTransactionHistory.vue?vue&type=template&id=438fc426&"
import script from "./ClientTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./ClientTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports